import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import PersonService from "../../../Services/Person.service";
import CourseSectionScheduleElementService from "../../../Domain/CourseSectionScheduleElement/CourseSectionScheduleElement.service";
import ResponsiveTable from "../../UI/ResponsiveTable/ResponsiveTable";
export const CourseSectionScheduleElementsTable = ({ courseSectionScheduleElements, }) => {
    const [amIAdministrator, setAmIAdministrator] = useState(false);
    useEffect(() => {
        PersonService.amIAdministrator().then(setAmIAdministrator);
    }, []);
    if (courseSectionScheduleElements &&
        courseSectionScheduleElements.some((csse) => csse.status.id === 1)) {
        return (_jsx("div", { className: "mb-3 border-top", children: _jsx(ResponsiveTable, { hover: true, striped: true, columns: [
                    {
                        title: "Schedule",
                    },
                    {
                        title: "Meeting Type",
                    },
                    {
                        title: "Location",
                    },
                    {
                        title: "Building",
                    },
                    {
                        title: "Room",
                    },
                    {
                        title: "Instructor",
                    },
                ], rows: courseSectionScheduleElements.map((csse, index) => {
                    var _a, _b, _c, _d, _e, _f, _g;
                    return [
                        CourseSectionScheduleElementService.getWeekDisplayString(csse, ",") +
                            " | " +
                            CourseSectionScheduleElementService.getTimeDisplayString(csse.startTimeHours24, csse.startTimeMinutes24) +
                            " - " +
                            CourseSectionScheduleElementService.getTimeDisplayString(csse.endTimeHours24, csse.endTimeMinutes24),
                        csse.meetingType,
                        amIAdministrator ? (_jsx(Link, { to: "/aviso/location/show/" + ((_a = csse === null || csse === void 0 ? void 0 : csse.location) === null || _a === void 0 ? void 0 : _a.id.toString()), target: "_blank", children: (_b = csse === null || csse === void 0 ? void 0 : csse.location) === null || _b === void 0 ? void 0 : _b.name })) : ((_c = csse === null || csse === void 0 ? void 0 : csse.location) === null || _c === void 0 ? void 0 : _c.name),
                        amIAdministrator ? (_jsx(Link, { to: "/aviso/buildingAdmin/show/" + ((_d = csse === null || csse === void 0 ? void 0 : csse.building) === null || _d === void 0 ? void 0 : _d.id.toString()), target: "_blank", children: (_e = csse === null || csse === void 0 ? void 0 : csse.building) === null || _e === void 0 ? void 0 : _e.name })) : ((_f = csse === null || csse === void 0 ? void 0 : csse.building) === null || _f === void 0 ? void 0 : _f.name),
                        csse === null || csse === void 0 ? void 0 : csse.room,
                        (_g = csse === null || csse === void 0 ? void 0 : csse.instructor) === null || _g === void 0 ? void 0 : _g.fullName,
                    ];
                }) }) }));
    }
    return null;
};
